// ======================================================================
// File Name       : configFile
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const GET_DOWNLOAD_CONFIG_FILE_RESULT = 'GET_DOWNLOAD_CONFIG_FILE_RESULT';
export const RESET_DOWNLOAD_CONFIG_FILE = 'RESET_DOWNLOAD_CONFIG_FILE';
export const GET_UPLOAD_CONFIG_FILE_RESULT = 'GET_UPLOAD_CONFIG_FILE_RESULT';
export const RESET_UPLOAD_CONFIG_FILE = 'RESET_UPLOAD_CONFIG_FILE';
